module.exports = __webpack_public_path__ + "img/common_icon_machine.1630d7c3.png";